import { registerEnumType } from 'type-graphql'

export enum CreditTransactionTypeEnum {
  Debit = 'Debit',
  Grant = 'Grant',
  Adjustment = 'Adjustment',
  Purchase = 'Purchase',
}

registerEnumType(CreditTransactionTypeEnum, {
  name: 'CreditTransactionTypeEnum',
  description:
    'Ledger entry type for a CreditTransaction — Debit consumes balance, Grant adds it (admin, free), Purchase adds it (bought by the owner), Adjustment is a manual correction.',
})
